var $ = jQuery;

$(window).load(function(){

  let $caseStudySidebar = $('#case-study-sidebar');

  if($caseStudySidebar.length) {

    let currentCsSection = "intro";
    let csSectionTransition = false;
    let checkSubsection = false;
    const $body = $('body');
    const $caseStudySubSections = $(".st-case-subsection");
    const $csTransitionSection = $('#case-study-transition-section');
    const $csProcessSection = $('#case-study-process-section');
    const $csConclusionSection = $('#case-study-conclusion');
    let currentCsSubSection = "research";
    let currentCsSubSectionNum = 1;
    let switchSubStations = false;

    $(window).on ('scroll', function() {
      const $window = $(window);
      const scrollViewPos = $window.scrollTop() + $window.height()/2;

      if ( $window.scrollTop() + $window.height()*.75 > $csConclusionSection.position().top ) {
        if(!csSectionTransition) {
          csSectionTransition = true;
          if(currentCsSection === "intro") {
            animateCsSidebar("intro", "-hide");
          } else {
            animateCsSidebar("process", "-hide");
            animateCsSidebar("nodelist", "-hide");
          }
          currentCsSection = "";
          checkSubsection = false;
        }
      } else if ( scrollViewPos > $csProcessSection.position().top ) {
        if(currentCsSection !== "process") {
          currentCsSection = "process";
          animateCsSidebar("process", "-show");
          animateCsSidebar("nodelist", "-show");

          if(!csSectionTransition) {
            animateCsSidebar("intro", "-hide");
          }
          csSectionTransition = false;
          checkSubsection = true;
        }
      } else if ( scrollViewPos > $csTransitionSection.position().top ) {
        if(!csSectionTransition) {
          csSectionTransition = true;
          if(currentCsSection === "intro") {
            animateCsSidebar("intro", "-hide");
          } else {
            animateCsSidebar("process", "-hide");
            animateCsSidebar("nodelist", "-hide");
          }
          currentCsSection = "";
          checkSubsection = false;
        }
      } else {
        if(currentCsSection !== "intro") {
          currentCsSection = "intro";
          animateCsSidebar("intro", "-show");

          if(!csSectionTransition) {
            animateCsSidebar("process", "-hide");
            animateCsSidebar("nodelist", "-hide");
          }
          csSectionTransition = false;
          checkSubsection = false;
        }
      }

      if(checkSubsection) {
        $caseStudySubSections.each(function() {
          $this = $(this);
          if (scrollViewPos > $this.position().top){
            const whichSubSection = $this.data('progress');
            const whichSubSectionNum = $this.data('number');
            if(currentCsSubSection !== whichSubSection) {
              switchSubStations = true;
            } else {
              switchSubStations = false;
            }
            currentCsSubSection = whichSubSection;
            currentCsSubSectionNum = whichSubSectionNum;
          }
        });
        if(switchSubStations){
          $('.st-case-study-sidebar-wrap a').removeClass('-active');
          $('.st-subsection-label-'+currentCsSubSection).addClass('-active');
          $('#cs-sidebar-title').text(currentCsSubSection);
          $('#cs-sidebar-title').attr('data-number', currentCsSubSectionNum);
          switchSubStations = false;
        }
      }
    });
  }

  function animateCsSidebar(whichSidebar, classname) {
    let sidebar = document.getElementById("case-study-sidebar-"+whichSidebar);
    sidebar.classList.remove('-hide', '-show');
    sidebar.classList.add(classname);
    let newsidebar = sidebar.cloneNode(true);
    sidebar.parentNode.replaceChild(newsidebar, sidebar);
  }

});